import { render, staticRenderFns } from "./TwoStepsVerification.vue?vue&type=template&id=fcced3d0&scoped=true&"
import script from "./TwoStepsVerification.vue?vue&type=script&lang=js&"
export * from "./TwoStepsVerification.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepsVerification.vue?vue&type=style&index=0&id=fcced3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcced3d0",
  null
  
)

export default component.exports